export class Router {
  path = $state(window.location.pathname);

  constructor() {
    window.addEventListener('popstate', () => {
      this.path = window.location.pathname;
    });
  }

  navigate(path: string): void {
    if (path === this.path) return;
    window.history.pushState({}, '', path);
    this.path = path;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
